import React from 'react';
import { Block } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { Stack, Typography } from '@mui/material';
import { PageContainer } from 'components/shared/Page/PageContainer';

export const AccessDenied = () => {
  return (
    <PageContainer title="Access Denied">
      <Stack alignItems="center" justifyContent="center" height="80vh" spacing={2}>
        <Block sx={{ color: grey['600'], fontSize: '8rem' }} />

        <Typography sx={{ fontSize: '2.25rem' }} variant="h6" component="span" color="textSecondary">
          Access Denied
        </Typography>

        <Typography variant="body1" color="textSecondary">
          You don't have permission to access this page.
        </Typography>
      </Stack>
    </PageContainer>
  );
};
